import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import { LoginIssueType, type LoginIssue } from './index.type'
import Ripple from '@/components/Ripple'
export default React.memo(function UnableLogin() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const VerActionItems = useMemo<LoginIssue[]>(
    () => [
      {
        description: t("我忘记密码了"),
        issueType: LoginIssueType.FORGOT_PASSWORD
      },
      // {
      //   description: "双重验证无法正常使用",
      //   issueType: LoginIssueType.TWO_FA_AUTH
      // },
      // {
      //   description: "我需要更改电话号码",
      //   issueType: LoginIssueType.CHANGE_PHONE
      // },
      // {
      //   description: "我需要更改电子邮箱",
      //   issueType: LoginIssueType.CHANGE_EMAIL
      // }
    ],
    [t]
  )

  // 处理选择问题类型
  const handleSelectIssueType = (issueType: LoginIssueType) => () => {
    if (issueType === LoginIssueType.FORGOT_PASSWORD) {
      navigate(`/forgot-password`, {
        state: {
          issueType
        }
      })
    }
  }

  return (
    <PageLayout>
      <Header leftChildren={<Back />}
        centerChildren={<div className="text-3.75 font-medium text-black">{t("无法登录")}</div>} />
      <div className='px-6 py-6'>
        <div className='text-3.75 font-medium text-black border-[0.5px] border-b-solid border-b-[#808080] pb-2'>{t("选择问题")}</div>
        <div className='mt-6 space-y-2'>
          {VerActionItems.map((item) => (
            <Ripple key={item.issueType} className="rounded-2 w-full">
            <div className='flex justify-between items-center py-3' key={item.issueType} onClick={handleSelectIssueType(item.issueType)}>
              <div className='text-sm text-[#333333]'>{item.description}</div>
              <div><img className='w-2' src="/icon/right-info.svg" /></div>
            </div>
            </Ripple>
          ))}
        </div>
      </div>
    </PageLayout>
  )
})
